module.exports = __webpack_public_path__ + "img/Group 409.d3bac7af.svg";